<template>
    <div class="mainbody" @click="setLastTime">
        <router-view  
            @PlaySound="playSound"
            @StopPlay="stopPlay"
            @ControlLight="controlLight">
        </router-view>
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            top="40vh"
            :show-close="false">
            <div class="confirm-content">
                <div class="info">
                    <img src="@/assets/images/busImage/warning.png"/>
                    <div class="tips">由于长时间未进行操作账号将在<span>{{tipsMessage}}</span>秒后退出登录</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {uploadLogs} from '@/api/user'
import { getToken} from '@/utils/auth'
import tipsDialog from '@/components/tipsDialog'
import errorDialog from '@/components/errorDialog'
export default {
    name: "clientMain",
    components: { tipsDialog,errorDialog },
    data() {
        return {
            deviceNo: '',
            baseUrl: this.myStore.state.mainUrl,
            goBackUrl:this.baseUrl+'/login',
            lastTime: null, // 最后一次点击的时间
            currentTime: null, // 当前点击的时间
            timeOut:  15 * 60 * 1000, // 5分钟
            dialogVisible: false,
            tipsMessage:'15'
        }
    },
    created() {
         this.$router.push(this.baseUrl+'/login');
         let deviceNo = this.myStore.state.deviceNo;
         if(typeof(deviceNo) !== "undefined") {
             this.deviceNo = deviceNo;
         }
         // 打开页面时，记录第一次的时间
        this.lastTime = new Date().getTime();
    },
    destroyed () {
        if(this.timer)  clearInterval(this.timer)
        if(this.timerId) clearInterval(this.timerId)
    },
    //增加监听，为了防止组件复用，生命周期钩子失效问题
    watch: {
        $route(to, from) {
            localStorage.setItem('routerName', to.name)
            if(to.path === '/boaccount/client/main') {
                this.$router.push(this.baseUrl+'/login')
            } 
        }
    },
    methods: {
        async playSound(fileName) {
            var param = {};
            param.file = "./wav/" + fileName + ".wav";
            var result = await this.sys.call("play_sound", param);
            console.info(JSON.stringify(result));
            if (result.result == 0) {
                console.log("播放音频" + fileName)
            } else {
                console.error("播放音频发生错误:" + result.message);
            }
        },
        async stopPlay() {
            var param = {};
            var result = await this.sys.call("play_sound", param);
            console.info(JSON.stringify(result));
            if (result.result == 0) {
                console.log("停止播放音频")
            } else {
                console.error("停止播放音频发生错误:" + result.message);
            }
        },
        // 设置最后点击时间
        setLastTime(){
            this.lastTime = new Date().getTime();
            if(this.timer)  clearInterval(this.timer)
            if(this.timerId) clearInterval(this.timerId)
            this.timer = setInterval(() => {
                    this.isTimeOut()
                },1000 * 3)
        },
         // 点击超时的点击事件
        isTimeOut() {
            // 记录最新一次的点击的时间
            this.currentTime = new Date().getTime();
            if ((this.currentTime - this.lastTime > this.timeOut) && getToken()) {// 弹窗提示
                // 判断上次最后一次点击的时间和这次点击的时间间隔是否超时 timeOut 此处超时
                clearInterval(this.timer)
                let seconds = 15;
                let remainingSeconds = seconds;
                this.tipsMessage = remainingSeconds
                this.dialogVisible = true
                let that =  this
                this.timerId = setInterval(function() {
                    if (remainingSeconds === 0) {
                        that.dialogVisible = false
                        clearInterval(that.timerId);
                        uploadLogs({
                            content: '登录超时，自动退出',
                            errorCode: -2,
                            module: '退出登录'
                        }).catch(e => {})
                        that.$store.dispatch('LogOut').then(() => {
                            that.$router.push({name: 'login'})
                        })
                        that.sys.delete({file: '.\\service\\IST_Simulator\\scanPic'})

                    } else {
                        remainingSeconds--;
                        that.tipsMessage = remainingSeconds
                    }
                }, 1000);
            }
        },
        async controlLight(port, value) {
            let lightName = '提示灯的名字';
            let actionName = '';

            let param = {};
			//需要和配置文件名称相同
			//param.port = "printer_light";
			//时间也行,时间就是变化的毫秒 flash是500ms
			//param.value = "flash";

            param.port = port;
			param.value = value; // 0 灭		1 常亮		其他>0的值时闪烁时间间隔
			let result = await this.siu.setOutput(param);
			console.info(JSON.stringify(result));
            switch (port) {
                case 'eject_light':
                    lightName = '退票口提示灯';
                    break;
                case 'printer_light':
                    lightName = '打印机提示灯';
                    break;
                default:
                    break;
            }
            if (value == 0) {
                actionName = '熄灭';
            } else {
                actionName = '点亮';
            }
			if (result.result == 0) {
				console.info(actionName + lightName + "成功");
			} else {
				console.error(actionName + lightName + "失败,错误:" + result.message);
			}
        }
    }
}
</script>

<style lang="less" scoped>
    .mainbody,.el-container.is-vertical{
        height: 100%;
    }
    .frame-header{
        background: linear-gradient(rgba(81, 152, 521, 1) 50%, rgba(71, 144, 255, 1) 50%);
        border-bottom: 2px solid #577899;
        height: 9% !important;
        text-align: left;
    }
    .frame-footer {
        background-color: white;
        height: 7% !important;
    }
    .frame-main {
        background-color: #f5f5f5;
        background-size: 100% 100%;
        background-position: center;
        background-attachment: fixed;
        height: 84%;
    }
    .el-row,.el-col,.logo{
        height: 100%;
    }
    .el-col{
        display:flex;
    }
    .logo {
        left: 2rem;
        color: #fff;
    }
    .timeout {
        right: 2rem;
        color: #fff;
    }
    .hbt {
        font-size: 3rem;
        padding: 0;
    }
    .confirm-content {
        .info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            img {
                width: 44px;
                height: 44px;
            }
            .tips {
                margin-left: 12px;
                margin-top: 5px;
                font-weight: 500;
                font-size: 32px;
                color: rgba(0,0,0,0.85);
                span{
                    margin: 0 5px;
                    color: #BE5852;
                }
            }
        }
        
    }
    /deep/ .el-dialog__header {
        padding: 0;
    }
    
</style>